export default __webpack_public_path__ + "static/favicon-74689d635d0d8bce90dc622b60040551.ico";